import SimpleLightbox from 'simplelightbox';
import 'simplelightbox/dist/simple-lightbox.min.css';

document.addEventListener('DOMContentLoaded', () => {
    new SimpleLightbox('.gallery-lightbox', {
        captions: false,
        overlayOpacity: 0.8,
        animationSpeed: 200,
        scrollZoom: false, // désactive le zoom avec la molette
    });
});